<div class="layout-column custom-panel visit-plan-audit-log">
  <!-- Header -->
  <div class="layout-row layout-align-start-center header padding-15">
    <span class="br-body-1 font-weight-600 flex title-text">
      Audit Log {{ visitPlan?.name ? visitPlan.name : '' }}
    </span>
    <bringoz-button type="tertiary" (onClick)="onCancel()">
      <bringoz-icon iconName="close" class="close-icon"></bringoz-icon>
    </bringoz-button>
  </div>

  <!-- Filters Toolbar -->
  <div class="layout-row layout-align-start-center filter-toolbar padding-15 gap-15">
    <!-- Category Dropdown Select -->
    <div class="filter-item flex-20 select-wrapper">
      <app-bringoz-select [options]="filterOperations"
                          [selectedValue]="selectedOperation"
                          [placeholder]="'By operation'"
                          (onValueChange)="onOperationChange($event)">
        <ng-template #ngLabelTmp>
          {{ 'VISIT_PLAN_AUDIT_LOG.' + selectedOperation | translate }}
        </ng-template>
        <ng-template #ngOptionTmp let-item>
          {{ 'VISIT_PLAN_AUDIT_LOG.' + item | translate }}
        </ng-template>
      </app-bringoz-select>
    </div>

    <!-- Date Range Selection -->
    <div class="filter-item flex-25">
      <app-bringoz-date-range-picker [selectedRange]="selectedRange"
                                     [customTemplates]="customTemplates"
                                     (onChange)="onRangeChange($event)">
      </app-bringoz-date-range-picker>
    </div>
  </div>

  <!-- Loading indicator - only for page/filter fetches once the first load has already painted -->
  <app-bringoz-linear-progress *ngIf="isLoading && isInitialized"></app-bringoz-linear-progress>

  <!-- Main Table View -->
  <div class="table-container flex layout-column" style="overflow: hidden;">

    <!-- Table Skeleton, shown only until the audit logs have loaded for the first time -->
    <div *ngIf="!isInitialized" class="flex layout-column bringoz-table bringoz-table-skeleton fade-element-in-only">
      <div class="layout-row layout-align-start-center tr-header">
        <div class="th col-timestamp"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-by"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-action"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-agent"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-account"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-for-days"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-current-state"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      </div>

      <div class="layout-row layout-align-start-center tr" *ngFor="let row of skeletonRows">
        <div class="td col-timestamp"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div></div>
        <div class="td col-by"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div></div>
        <div class="td col-action"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 80%"></div></div>
        <div class="td col-agent"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div></div>
        <div class="td col-account"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div></div>
        <div class="td col-for-days"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 55%"></div></div>
        <div class="td col-current-state"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 50%"></div></div>
      </div>
    </div>

    <!-- Table -->
    <app-bringoz-data-table *ngIf="isInitialized"
                            class="flex layout-column"
                            [uniqueId]="tableUniqueId"
                            [defaultWidths]="defaultWidths"
                            [items]="auditLogs"
                            [rowHeight]="rowHeight"
                            [resizable]="true"
                            [isLoading]="isLoading"
                            (fetchNext)="onFetchNext()">

      <ng-template tableHeader>
        <div class="th col-timestamp text-ellipsis">Timestamp</div>
        <div class="th col-by text-ellipsis">By</div>
        <div class="th col-action text-ellipsis">Action</div>
        <div class="th col-agent text-ellipsis">Agent</div>
        <div class="th col-account text-ellipsis">Account</div>
        <div class="th col-for-days text-ellipsis">For Days</div>
        <div class="th col-current-state text-ellipsis">Current State</div>
      </ng-template>

      <ng-template tableRow let-log>
        <div class="tr layout-row layout-align-start-center item">
          <div class="td col-timestamp text-ellipsis">{{ log.formattedDate }}</div>
          <div class="td col-by text-ellipsis">{{ log.by }}</div>
          <div class="td col-action text-ellipsis">{{ 'VISIT_PLAN_AUDIT_LOG.' + log.action | translate }}</div>
          <div class="td col-agent">
            <ng-container *ngIf="log.agentIds?.length; else noAgent">
              <ng-container *ngIf="log.agentDisplay; else agentSkeleton">
                <app-bringoz-items-list-display *ngIf="log.agentDisplay.length; else noAgent" [items]="log.agentDisplay" [maxItems]="2"></app-bringoz-items-list-display>
              </ng-container>
              <ng-template #agentSkeleton><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div></ng-template>
            </ng-container>
            <ng-template #noAgent>{{ log.agentsCount ? ('VISIT_PLAN_AUDIT_LOG.X_AGENTS' | translate: {count: log.agentsCount}) : '---' }}</ng-template>
          </div>
          <div class="td col-account">
            <ng-container *ngIf="log.accountIds?.length; else noAccount">
              <ng-container *ngIf="log.accountDisplay; else accountSkeleton">
                <app-bringoz-items-list-display *ngIf="log.accountDisplay.length; else noAccount" [items]="log.accountDisplay" [maxItems]="1"></app-bringoz-items-list-display>
              </ng-container>
              <ng-template #accountSkeleton><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div></ng-template>
            </ng-container>
            <ng-template #noAccount>{{ log.accountsCount ? ('VISIT_PLAN_AUDIT_LOG.X_ACCOUNTS' | translate: {count: log.accountsCount}) : '---' }}</ng-template>
          </div>
          <div class="td col-for-days">
            <app-bringoz-items-list-display *ngIf="log.forDays?.length; else noForDays" [items]="log.forDays" [maxItems]="1"></app-bringoz-items-list-display>
            <ng-template #noForDays>{{ log.forDaysCount ? ('VISIT_PLAN_AUDIT_LOG.X_DAYS' | translate: {count: log.forDaysCount}) : '---' }}</ng-template>
          </div>
          <div class="td col-current-state layout-row layout-align-start-center">
            <span *ngIf="log.status === AuditLogStatus.Success" class="status-tag success">Success</span>
            <span *ngIf="log.status === AuditLogStatus.Failed" class="status-tag failure">Failure</span>
            <span *ngIf="log.status !== AuditLogStatus.Success && log.status !== AuditLogStatus.Failed" class="status-tag default">{{ log.status || '-----' }}</span>
          </div>
        </div>
      </ng-template>

      <app-empty-state tableEmptyState
                       src="assets/images/empty_state/empty_state_history.png"
                       text="No logs match your search criteria.">
      </app-empty-state>

    </app-bringoz-data-table>
  </div>
</div>
